// extracted by mini-css-extract-plugin
export default {"container":"Vehicles_container__j5u7t","title":"Vehicles_title__d3-5W","linkContainer":"Vehicles_linkContainer__ftJJV"};